/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EntityCustomMetadataEntryDto = {
    id: string;
    type: EntityCustomMetadataEntryDto.type;
};

export namespace EntityCustomMetadataEntryDto {

    export enum type {
        LABEL = 'LABEL',
        USER = 'USER',
        STRING = 'STRING',
        TEAM = 'TEAM',
    }


}
